module.exports = __webpack_public_path__ + "static/media/insightsLogo.f420cd82.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hall/insightsLogo.svg
// module id = 1255
// module chunks = 0